module.exports = __webpack_public_path__ + "img/blogs.a3e77933.svg";